import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { InjectedFieldProps, PublicFieldProps, sanitizeFieldRestProps } from 'ra-ui-materialui';
import { ElementType, FC } from 'react';
import { getTranslatedFieldValues } from "../../../provider/I18nProvider";

export const translateFieldValue = (props) => {
    if (!props || !props.record) return;
    const baseValue = props.record[props.source];
    const values = getTranslatedFieldValues(props.source, props.resource)
    return values[baseValue] || baseValue;
};

/**
 * Cherche d'abord dans l'ordre suivant :
 *   - resources.${props.resource}.${props.source}.${baseValue}
 *      ex: resources.workflow.status.DRAFT
 *   - resources.${props.source}.${baseValue}
 *      ex: resources.status.DRAFT
 * @param props props
 * @returns translate value
 */
const TranslateField: FC<TranslateFieldProps> = (props: any) => {
    const value = translateFieldValue(props);
    const { className, source, emptyText, ...rest } = props;
    return <Typography
        component="span"
        variant="body2"
        className={className}
        {...sanitizeFieldRestProps(rest)}
    >
        {value != null && typeof value !== 'string'
            ? JSON.stringify(value)
            : value || emptyText}
    </Typography>
};

// what? TypeScript loses the displayName if we don't set it explicitly
TranslateField.displayName = 'TranslateField';

TranslateField.defaultProps = {
    addLabel: true
};

export interface TranslateFieldProps
    extends PublicFieldProps,
    InjectedFieldProps,
    TypographyProps {
    // TypographyProps do not expose the component props, see https://github.com/mui-org/material-ui/issues/19512
    component?: ElementType<any>;
}

export default TranslateField;